import React from "react";
import PropTypes from "prop-types";

const AIIcon = ({ width = 32, height = 30 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.713 5.32658C12.975 4.33326 14.3849 4.33326 14.6469 5.32658L15.8314 9.8179C16.1932 11.1899 17.2548 12.2675 18.6212 12.6499L23.2851 13.955C24.28 14.2334 24.2509 15.6539 23.2454 15.8913L18.7801 16.9454C17.3272 17.2884 16.1862 18.412 15.8208 19.8594L14.6496 24.4992C14.3954 25.5062 12.9646 25.5062 12.7104 24.4992L11.5391 19.8594C11.1737 18.412 10.0327 17.2884 8.57984 16.9454L4.11454 15.8913C3.10903 15.6539 3.07989 14.2334 4.07482 13.955L8.73872 12.6499C10.1051 12.2675 11.1667 11.1899 11.5285 9.8179L12.713 5.32658Z"
      fill="url(#paint0_linear_104_237)"
    />
    <path
      d="M24.7966 2.33321C24.9275 1.83655 25.6325 1.83655 25.7635 2.33321L26.2963 4.35338C26.4772 5.03938 27.008 5.57819 27.6912 5.76938L29.7926 6.35743C30.2901 6.49663 30.2755 7.20686 29.7727 7.32555L27.7706 7.79821C27.0442 7.96971 26.4737 8.53147 26.291 9.25519L25.7648 11.3395C25.6377 11.843 24.9223 11.843 24.7952 11.3395L24.2691 9.25519C24.0864 8.53147 23.5159 7.96971 22.7894 7.79821L20.7873 7.32555C20.2846 7.20686 20.27 6.49664 20.7675 6.35743L22.8689 5.76938C23.5521 5.57819 24.0829 5.03938 24.2638 4.35338L24.7966 2.33321Z"
      fill="url(#paint1_linear_104_237)"
    />
    <path
      d="M24.7966 18.5734C24.9275 18.0768 25.6325 18.0768 25.7635 18.5734L26.2963 20.5936C26.4772 21.2796 27.008 21.8184 27.6912 22.0096L29.7926 22.5977C30.2901 22.7369 30.2755 23.4471 29.7727 23.5658L27.7706 24.0384C27.0442 24.2099 26.4737 24.7717 26.291 25.4954L25.7648 27.5798C25.6377 28.0833 24.9223 28.0833 24.7952 27.5798L24.2691 25.4954C24.0864 24.7717 23.5159 24.2099 22.7894 24.0384L20.7873 23.5658C20.2846 23.4471 20.27 22.7369 20.7675 22.5977L22.8689 22.0096C23.5521 21.8184 24.0829 21.2796 24.2638 20.5936L24.7966 18.5734Z"
      fill="url(#paint2_linear_104_237)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_104_237"
        x1="8.24515"
        y1="6.46256"
        x2="24.5658"
        y2="19.6244"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F8BE9" />
        <stop offset="0.701923" stopColor="#9853E0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_104_237"
        x1="22.6808"
        y1="2.7968"
        x2="30.4863"
        y2="9.09158"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F8BE9" />
        <stop offset="0.701923" stopColor="#9853E0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_104_237"
        x1="22.6808"
        y1="19.037"
        x2="30.4863"
        y2="25.3318"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F8BE9" />
        <stop offset="0.701923" stopColor="#9853E0" />
      </linearGradient>
    </defs>
  </svg>
);

AIIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
export default AIIcon;
